<template>
  <div class="d-flex align-items-center">
    {{ fullName(technician) }}
    <Tooltip placement="top" :options="{ hideOnClick: true }">
      <template #trigger>
        <button
          type="button"
          class="-my-3 -ml-1 -mr-3 p-3 link"
          aria-label="Change commissions"
          @click="commissionModal || toggleModal()"
        >
          <i class="fas fa-edit"></i>
        </button>
      </template>
      <template #tooltip>
        <div class="text-center">Change commissions.</div>
      </template>
    </Tooltip>
    <JobCommissionModal
      v-if="commissionModal"
      :job-id="jobId"
      :commissions="commissions"
      @hide-modal="toggleModal"
    />
  </div>
</template>

<script>
import JobCommissionModal from "./JobCommissionsModal.vue";
import Tooltip from "../../components/Tooltip.vue";
import { mapActions } from "vuex";

export default {
  components: {
    JobCommissionModal,
    Tooltip
  },
  props: {
    jobId: {
      type: Number,
      default: null
    },
    technician: {
      type: Object,
      default: () => ({})
    },
    commissions: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      commissionModal: false
    };
  },
  methods: {
    ...mapActions(["clearJob"]),
    toggleModal() {
      this.commissionModal = !this.commissionModal;
      if (!this.commissionModal) {
        this.clearJob();
      }
    }
  }
};
</script>

<style lang="scss" scoped></style>
